import './cfl-ms-25-characters.swiper.js';

// Tabs show/hide logic for CFL MS 25 Characters
// Swiper logic is separated in cfl-ms-25-characters.swiper.js

// Swiper module is split into cfl-ms-25-characters.swiper.js

window.addEventListener("load", function () {
    var $section = $('#cfl-ms-25-characters');
    if (!$section.length) return;

    // Init active tab on load
    var $tabLinks = $section.find('.list-tabs a');
    var $activeLink = $tabLinks.filter('.active');
    if (!$activeLink.length) $activeLink = $tabLinks.first().addClass('active');
    var initialTarget = $activeLink.data('target');
    $section.find('.tab-content').hide().removeClass('active');
    if (initialTarget) $(initialTarget).show().addClass('active');

    // Handle tab clicks
    $section.on('click', '.list-tabs a', function (e) {
        e.preventDefault();
        var $link = $(this);
        var target = $link.data('target');
        if (!target) return;

        $link.addClass('active').siblings('a').removeClass('active');
        $section.find('.tab-content').hide().removeClass('active');
        $(target).show().addClass('active');

        // Notify swiper module to update after tab is shown
        $section.trigger('tab:shown');

        // Trigger first avatar for any visible slide with list-btns after switching tab
        triggerFirstAvatarInActiveSlides($(target));
    });

    // ========== Avatar list toggle logic ==========
    // Behavior contract:
    // - Within each .swiper-slide, clicking an .avatar will:
    //   + add .active to the clicked .avatar and remove from siblings
    //   + if the slide contains multiple .avatar-content blocks: show ONLY the
    //     .avatar-content at the same index, hide the others (and toggle an .active class)
    //   + otherwise (no .avatar-content wrappers present), leave images as-is (fallback)

    function setActiveAvatar($slide, index) {
        var $list = $slide.find('.list-btns');
        var $avatars = $list.find('.avatar');
        if (!$avatars.length) return;
        var idx = Math.max(0, Math.min(index, $avatars.length - 1));
        $avatars.removeClass('active').eq(idx).addClass('active');

        // Preferred: toggle .avatar-content wrappers by index
        var $wrappers = $slide.children('.avatar-content');
        if ($wrappers.length) {
            var showIdx = idx % $wrappers.length;
            $wrappers
                .removeClass('active')
                .hide();
            $wrappers.eq(showIdx)
                .addClass('active')
                .show();
            return;
        }

        // Fallback: if no wrappers, do not try to pair PC/MB images by index.
        // Just ensure any previously forced inline styles are cleared for direct character images.
        // Note: visibility for .MS__pc / .MS__mb is controlled by CSS media queries.
        var $directImages = $slide.children('.character-image');
        if ($directImages.length) {
            $directImages.removeClass('active').css('display', '');
        }
    }

    function triggerFirstAvatarInActiveSlides($root) {
        var $scope = $root && $root.length ? $root : $section;
        // For each visible swiper-slide with list-btns, set first active
        $scope.find('.swiper-characters-content .swiper-slide').each(function () {
            var $slide = $(this);
            if (!$slide.closest('.tab-content').hasClass('active')) return;
            if ($slide.find('.list-btns .avatar').length) {
                setActiveAvatar($slide, 0);
            }
        });
    }

    // Delegate click from avatars
    $section.on('click', '.swiper-characters-content .swiper-slide .list-btns .avatar', function (e) {
        e.preventDefault();
        var $avatar = $(this);
        var $slide = $avatar.closest('.swiper-slide');
        var $avatars = $avatar.parent().find('.avatar');
        var idx = $avatars.index($avatar);
        setActiveAvatar($slide, idx);
    });

    // Initial trigger on load for active tab
    triggerFirstAvatarInActiveSlides($section);

    // When swiper content changes slide, auto trigger first avatar for that slide
    // We rely on swiper module storing swiper instance on DOM via .swiper
    function bindSwiperSlideInit() {
        $section.find('.swiper-characters-content').each(function () {
            var contentSwiper = this.swiper;
            if (!contentSwiper || contentSwiper.__avatarBound) return;
            contentSwiper.__avatarBound = true;

            contentSwiper.on('slideChangeTransitionEnd', function () {
                var idx = contentSwiper.activeIndex || 0;
                var slideEl = contentSwiper.slides && contentSwiper.slides[idx];
                if (!slideEl) return;
                var $slide = $(slideEl);
                if ($slide.find('.list-btns .avatar').length) {
                    setActiveAvatar($slide, 0);
                }
            });
        });
    }

    // Bind now and also after tab shown (swiper module re-inits things)
    bindSwiperSlideInit();
    $section.on('tab:shown', function () {
        bindSwiperSlideInit();
        // Also ensure first avatar is set after tab switch
        triggerFirstAvatarInActiveSlides($section);
    });
});

